"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("../browser");
const paramKeys_1 = require("../paramKeys");
/**
 * Note: Most of the code in this file was pulled from the ga.js
 * file. Some typing was added, some refactoring was done, but
 * generally it was left as-is.
 */
const initField = (hash, key) => {
    const c = hash[key];
    if (isNaN(c) || Infinity === c || 0 > c) {
        hash[key] = undefined;
    }
};
const Ec = (api, perfs) => {
    let performance = browser_1.default.getWindow().performance || browser_1.default.getWindow().webkitPerformance;
    performance = performance && performance.timing;
    if (!performance) {
        return false;
    }
    const navStart = performance.navigationStart;
    if (navStart === 0) {
        return false;
    }
    perfs[paramKeys_1.default.TimingEb] = performance.loadEventStart - navStart;
    perfs[paramKeys_1.default.TimingGb] = performance.domainLookupEnd - performance.domainLookupStart;
    perfs[paramKeys_1.default.TimingJb] = performance.connectEnd - performance.connectStart;
    perfs[paramKeys_1.default.TimingIb] = performance.responseStart - performance.requestStart;
    perfs[paramKeys_1.default.TimingFb] = performance.responseEnd - performance.responseStart;
    perfs[paramKeys_1.default.TimingHb] = performance.fetchStart - navStart;
    perfs[paramKeys_1.default.TimingKb] = performance.domInteractive - navStart;
    perfs[paramKeys_1.default.TimingLb] = performance.domContentLoadedEventStart - navStart;
    perfs[paramKeys_1.default.TimingVe] = api.L - navStart;
    perfs[paramKeys_1.default.TimingWe] = api.ya - navStart;
    return true;
};
const Fc = (perfs) => {
    if (browser_1.default.getWindow().top !== browser_1.default.getWindow()) {
        return false;
    }
    const ext = browser_1.default.getWindow().external;
    let c = ext && ext.onloadT;
    ext && !ext.isValidLoadTime && (c = undefined);
    2147483648 < c && (c = undefined);
    0 < c && ext.setPageReadyTime();
    if (c === undefined) {
        return false;
    }
    perfs[paramKeys_1.default.TimingEb] = c;
    return true;
};
const collectPerformanceValues = (api, callback) => {
    const perfs = {};
    if (Ec(api, perfs) || Fc(perfs)) {
        const c = perfs[paramKeys_1.default.TimingEb];
        undefined === c || Infinity === c || isNaN(c) || (0 < c ? (initField(perfs, paramKeys_1.default.TimingGb),
            initField(perfs, paramKeys_1.default.TimingJb),
            initField(perfs, paramKeys_1.default.TimingIb),
            initField(perfs, paramKeys_1.default.TimingFb),
            initField(perfs, paramKeys_1.default.TimingHb),
            initField(perfs, paramKeys_1.default.TimingKb),
            initField(perfs, paramKeys_1.default.TimingLb),
            initField(perfs, paramKeys_1.default.TimingVe),
            initField(perfs, paramKeys_1.default.TimingWe),
            setTimeout(() => {
                callback(perfs);
            }, 10)) : browser_1.default.setEvent(browser_1.default.getWindow(), 'load', () => {
            collectPerformanceValues(api, callback);
        }, false));
    }
};
const timing = () => {
    return (tracker) => {
        if ('pageview' === tracker.params.get(paramKeys_1.default.HitType) && !tracker.timing) {
            tracker.timing = true;
            collectPerformanceValues(tracker.api, (e) => {
                tracker.send('timing', e);
            });
        }
    };
};
exports.default = timing;
